<template>
  <ul class="detail-list">
    <difficulty-rating tag-is="li" :difficulty="metaData.difficulty">
      <contextual-help id="difficulty" title="Difficulty:" classes="-flush -label">
        <p>Difficulty levels set by weighted average of workout minutes for each level.</p>
      </contextual-help>
    </difficulty-rating>
    <li>
      <span class="detail-title">
        <contextual-help id="minutes" title="Daily Duration:" classes="-flush -label">
          <p>
            The average daily duration in minutes for the required routine workouts. Optional and
            extra credit are not included.
          </p>
        </contextual-help>
      </span>
      <span class="detail-value"> Avg. {{ metaData.minutes }} Minutes </span>
    </li>
    <li>
      <span class="detail-title">
        <contextual-help id="bodyFocus" title="Body Focus:" classes="-flush -label">
          <p>The top body focus by workout minutes for the routine.</p>
        </contextual-help>
      </span>
      <span class="detail-value">
        {{ metaData.bodyFocus }}
      </span>
    </li>
    <li>
      <span class="detail-title">
        <contextual-help id="trainingType" title="Training Type:" classes="-flush -label">
          <p>The top four training types used by workout minutes for the routine.</p>
        </contextual-help>
      </span>
      <span class="detail-value">
        {{ metaData.trainingType }}
      </span>
    </li>
    <li>
      <span class="detail-title">
        <contextual-help id="equipment" title="Equipment:" classes="-flush -label">
          <p>The top four equipment used by workout minutes for the routine.</p>
        </contextual-help>
      </span>
      <span class="detail-value">
        {{ metaData.equipment }}
      </span>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState, mapActions } from 'pinia'
import { useRoutinesStore } from '@/stores/routines'
import ContextualHelp from '@/components/tool-tips/contextual-help.vue'
import DifficultyRating from '@/components/videos/difficulty-rating.vue'

/**
 * Component only shows routine meta data, but state / management is full outsourced
 * to pinia (routine module, which must be loaded as it is not in api.js).
 *
 * - can pass in props to set initial pinia state
 * - receives pinia state updates (from routine-edit-schedule.vue) when workouts deleted / days updated
 *
 */
export default defineComponent({
  name: 'RoutineMetaData',
  components: {
    ContextualHelp,
    DifficultyRating,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    status: {
      type: String,
      default: '',
    },
    weeks: {
      type: String,
      default: '',
    },
    minutes: {
      type: String,
      default: '',
    },
    minutesMin: {
      type: String,
      default: '',
    },
    minutesMax: {
      type: String,
      default: '',
    },
    daysWeek: {
      type: String,
      default: '',
    },
    difficulty: {
      type: Number,
      default: 0,
    },
    bodyFocus: {
      type: String,
      default: '',
    },
    equipment: {
      type: String,
      default: '',
    },
    trainingType: {
      type: String,
      default: '',
    },
  },

  data() {
    return {}
  },

  computed: {
    ...mapState(useRoutinesStore, ['metaData']),
  },

  created() {
    // set initial data into pinia
    this.setMetaData({
      weeks: this.weeks,
      minutes: this.minutes,
      minutesMin: this.minutesMin,
      minutesMax: this.minutesMax,
      daysWeek: this.daysWeek,
      difficulty: this.difficulty,
      bodyFocus: this.bodyFocus,
      equipment: this.equipment,
      trainingType: this.trainingType,
    })
  },

  methods: {
    ...mapActions(useRoutinesStore, ['setMetaData']),
  },
})
</script>
